<header class="navbar navbar-fixed-top bg-system">
    <div class="navbar-logo-wrapper">
        <a class="navbar-logo-text" href="/" ng-click="mainPage()">
            <img src="img/logo-blue.svg" alt="Hodxpress.com">
             
        </a>
    </div>

    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/gun-sonu">
                <strong class="p10 fs18">Gün Sonu Yönetimi</strong>
            </a>
        </li>
    </ul>
    <ul class="nav navbar-nav navbar-right">

        <li ng-class="{ active: isActiveStock('//gun-sonu?status=false')}" class="hidden-xs">
            <a href="/gun-sonu?status=false">
                Onaysız Gün Sonları
            </a>
        </li>
        <li ng-class="{ active: isActiveStock('//gun-sonu?status=true')}" class="hidden-xs">
            <a href="/gun-sonu?status=true">
                Onaylı Gün Sonları
            </a>
        </li>

    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['gun-sonu','gun-sonu?status=true','gun-sonu?status=false'])">
        
    <ul class="nav navbar-nav navbar-left">

        <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select>

        <select class="ml10 selectpicker" 
            title="Durum"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.status"
            data-style="btn-primary">
            <option data-select-watcher value="null">Hepsi</option>
            <option data-select-watcher value="true">Onaylı</option>
            <option data-select-watcher value="true">Onaysız</option>
        </select>
        
        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.date"
            class="btn btn-operation ml10" 
            placeholder="Tarih" >

        <a href="#" class="btn btn-warning ml10" ng-click="all()" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>
    

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Sil
        </a>
    </ul>

    <!-- <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="stok/urun/yeni" class="btn btn-warning btn-rounded">
                Yeni Gün Sonu Ekle 
            </a>
        </li>

    </ul> -->
    
</header>
